import { IParcelCulture } from 'components/generics/Interface/Api/Response/Exploitation/Parcels/IParcelCulture';
import { ICampaign } from 'components/generics/Interface/Exploitation/Parcels/ICampaign';
import { IParcelSimu } from 'components/generics/Interface/Simulation/IParcelSimu';
import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { displayErrorMessage } from 'utils/tools_functions';

type RenderConstraintNotRespectedParams = {
  year: any;
  index: number;
  constraintName: string;
  constraintDetailName: string;
  suggest: any;
  result: any;
  forecastCampaign: ICampaign;
};

export const RenderConstraintNotRespected = ({
  year,
  index,
  constraintName,
  constraintDetailName,
  suggest,
  result,
  forecastCampaign,
}: RenderConstraintNotRespectedParams): JSX.Element => {
  const { t } = useTranslation();
  let messageErrorDisplay: string = '';
  if (constraintName === 'restrictionDurationConstraint') {
    const parcelNameArray: string[] = [];
    for (const parcelIndex of year.errorsConstraints[constraintName].parcels) {
      parcelNameArray.push(suggest.parcels[parcelIndex].name);
    }
    messageErrorDisplay = t('simulation.constraintErrors.restrictionDuration', {
      startYear: forecastCampaign.startYear + index,
      endYear: forecastCampaign.endYear + index,
      parcels: parcelNameArray.join(', '),
    });
  } else if (constraintName === 'coversConstraint') {
    const parcelCoversArray: string[] = [];
    for (const parcelId of year.errorsConstraints[constraintName].parcels) {
      const parcel: string = suggest.parcels?.find(
        (parcel: IParcelSimu) => parcel?.id === parcelId,
      )?.name;

      const cultures: number[] =
        year.errorsConstraints[constraintName].cultures.find((cultureIds: number[]) =>
          cultureIds.some(() =>
            suggest.parcels?.some((parcel: IParcelSimu) => parcel.id === parcelId),
          ),
        ) || [];

      const cultureNames: string[] = cultures.map((cultureId: number) => {
        return result.cultures?.find((culture: IParcelCulture) => culture?.id === cultureId)?.name;
      });

      parcelCoversArray.push(
        t('simulation.constraintErrors.parcelWithCulture', {
          parcel,
          cultures: cultureNames.join(', '),
        }),
      );
    }

    messageErrorDisplay = t('simulation.constraintErrors.coverProposal', {
      startYear: forecastCampaign.startYear + index,
      endYear: forecastCampaign.endYear + index,
      parcels: parcelCoversArray.join(', '),
    });
  } else if (constraintName === 'TFIConstraint') {
    if (constraintDetailName === 'herbicideCompliant') {
      messageErrorDisplay = t('simulation.constraintErrors.iftHerbicide', {
        startYear: forecastCampaign.startYear + index,
        endYear: forecastCampaign.endYear + index,
        actual: year.averageTFIHerbicide,
        expected: result.constraints.TFI.maxHerbicide,
      });
    } else {
      messageErrorDisplay = t('simulation.constraintErrors.iftNonHerbicide', {
        startYear: forecastCampaign.startYear + index,
        endYear: forecastCampaign.endYear + index,
        actual: year.averageTFIWithoutHerbicide,
        expected: result.constraints.TFI.maxWithoutHerbicide,
      });
    }
  } else if (constraintName === 'violations') {
    let { error_code, additionalInfo } =
      year?.errorsConstraints?.[constraintName]?.[constraintDetailName];
    messageErrorDisplay = t('simulation.constraintErrors.violation', {
      error: displayErrorMessage(error_code, additionalInfo),
      startYear: forecastCampaign.startYear + index,
      endYear: forecastCampaign.endYear + index,
    });
  } else {
    const min: number =
      result.constraints[constraintName].filter(
        (constraintGlobalData: { displayName: string }) =>
          constraintGlobalData.displayName === constraintDetailName,
      )?.[0]?.['min'] || 0;
    const max: number | null =
      result.constraints[constraintName].filter(
        (constraintGlobalData: { displayName: string }) =>
          constraintGlobalData.displayName === constraintDetailName,
      )?.[0]?.['max'] || null;
    messageErrorDisplay = t('simulation.constraintErrors.generic', {
      constraintName: constraintDetailName,
      startYear: forecastCampaign.startYear + index,
      endYear: forecastCampaign.endYear + index,
      actual: year.errorsConstraints[constraintName][constraintDetailName],
      expected: `${min}${max ? ' - ' + max : ''}`,
    });
  }

  return (
    <div
      style={{
        backgroundColor: '#e74c3c',
        width: '100%',
        height: '50px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 10,
        borderRadius: 15,
        padding: '0 7px',
      }}
      key={index}
    >
      <span style={{ textAlign: 'center', color: '#fff', fontSize: 15 }}>
        {messageErrorDisplay}
      </span>
    </div>
  );
};
